module.exports = __webpack_public_path__ + "static/media/Poppins-Italic.64e838b9.otf";